import { Navigate } from 'react-router-dom'
import { PARCEIROS_LOGIN_PATH } from '@/pages/parceiros/parceirosBrand'

export default function PortalIndicacoesLogin() {
  return <Navigate to={PARCEIROS_LOGIN_PATH} replace />
}
